// H.2.4: /outreach/sequences/:id retired. SequenceCard is now a display-only
// card used by the sequences-list widget. To drill into a sequence, ask the
// agent: "show sequence <name>".

export interface SequenceSummary {
  name: string;
  trigger: { type: string; eventName: string };
  step_count: number;
  enrollment_count: number;
  exited_count: number;
}

export function SequenceCard({ sequence }: { sequence: SequenceSummary }) {
  return (
    <div
      className="block bg-card border border-border rounded-md p-4"
    >
      <div className="flex justify-between items-baseline mb-2">
        <div className="text-foreground font-medium">{sequence.name}</div>
        <div className="text-foreground-mute text-xs">
          {sequence.step_count} step{sequence.step_count !== 1 ? 's' : ''}
        </div>
      </div>
      <div className="text-foreground-mute text-xs mb-2">
        trigger: <span className="text-foreground">{sequence.trigger.eventName}</span>
      </div>
      <div className="flex gap-4 text-xs">
        <span className="text-foreground">
          <span className="font-medium">{sequence.enrollment_count}</span> active
        </span>
        <span className="text-foreground-mute">
          <span className="font-medium">{sequence.exited_count}</span> exited
        </span>
      </div>
    </div>
  );
}
